import React from 'react';
import PresenceStatusBadge from './PresenceStatusBadge';
import DeviceIcons from './DeviceIcons';
import LatencyIndicator from './LatencyIndicator';
import LastSeen from './LastSeen';

function PlayerPresenceRow({
  player,
  focused,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) {
  if (!player) return null;
  const {
    playerId,
    displayName,
    profilePhoto,
    status,
    devices = [],
    latencyMs,
    lastUpdatedAt,
  } = player;

  const fallbackAvatar =
    'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png';

  return (
    <div
      className={`d-flex align-items-center py-2 px-2 ${
        focused ? 'bg-light' : ''
      }`}
      role="button"
      tabIndex={-1}
      onClick={() => onClick?.(playerId)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ cursor: 'pointer' }}
    >
      <PresenceStatusBadge status={status} />
      <div className="me-2">
        <img
          src={profilePhoto || fallbackAvatar}
          alt={displayName || playerId}
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="flex-grow-1">
        <div className="fw-semibold">{displayName || playerId}</div>
        <div className="text-muted small">
          <LastSeen timestamp={lastUpdatedAt} />
        </div>
      </div>
      <div className="me-3">
        <DeviceIcons devices={devices} />
      </div>
      <LatencyIndicator latency={latencyMs} />
    </div>
  );
}

export default PlayerPresenceRow;
